import { ListItemText, Typography } from '@mui/material';

import StripedListItem from '../../Common/StripedListItem';
import { IPlaceSearchResult } from '../placeSearchTypes';
import SearchPlacesListItemActions from './searchPlacesListItemActions';

import uiStyles from "../../../Lib/UI/UI.module.css";


interface SearchPlacesListItemProps {
    item: IPlaceSearchResult;
    onView: (item: IPlaceSearchResult) => void;
}

const SearchPlacesListItem = (props: SearchPlacesListItemProps): JSX.Element => {

    const description = [props.item.district, props.item.county, props.item.postCodeDistrict].filter(v => !!v && v.length > 0).join(', ');

    return (
        <StripedListItem
            secondaryAction={
                <SearchPlacesListItemActions item={props.item} onView={props.onView} />
            }
        >

            <ListItemText 
                className={uiStyles.list_status}
                disableTypography
                primary={<Typography fontSize={{ xs: 20, md: 25 }}>{props.item.name}</Typography>}
                secondary={<Typography fontSize={{ xs: 15, md: 20 }}>{description}</Typography>}
            />

        </StripedListItem>
    );

};

export default SearchPlacesListItem;